import React from 'react';
import { Box, Card, CardContent, Typography, Grid } from '@mui/material';
import { AccountDummyDetails } from '../hooks/useAccountDetails';
import { StatusBadge } from '../../../../../../shared/components/ui/StatusBadge';

interface Props {
  details: AccountDummyDetails;
}

interface IntegrationCardProps {
  name: string;
  description: string;
  connected: boolean;
  value?: string | null;
}

const IntegrationCard: React.FC<IntegrationCardProps> = ({
  name,
  description,
  connected,
  value,
}) => (
  <Card
    variant="outlined"
    sx={{
      border: '1px solid #E2E8F0',
      borderRadius: '12px',
      boxShadow: '0px 1px 3px rgba(0,0,0,0.05), 0px 10px 15px -5px rgba(0,0,0,0.03)',
    }}
  >
    <CardContent sx={{ p: 3, '&:last-child': { pb: 3 } }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box>
          <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#0b1c30' }}>
            {name}
          </Typography>
          <Typography sx={{ fontSize: '14px', color: '#64748b', mt: 0.5 }}>
            {description}
          </Typography>
          {value && (
            <Typography
              sx={{
                fontSize: '12px',
                color: '#64748b',
                mt: 0.5,
                display: 'block',
                fontFamily: 'Courier Prime, monospace',
              }}
            >
              {value}
            </Typography>
          )}
        </Box>
        <StatusBadge
          label={connected ? 'Connected' : 'Not connected'}
          status={connected ? 'active' : 'neutral'}
        />
      </Box>
    </CardContent>
  </Card>
);

export const AccountDetailsIntegrationsTab: React.FC<Props> = ({ details }) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <IntegrationCard
            name="Google Calendar"
            description="Sync appointments with Google Calendar"
            connected={details.googleCalendarConnected}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <IntegrationCard
            name="Messaging"
            description="SMS and messaging provider for appointment reminders"
            connected={details.messagingProvider !== null}
            value={details.messagingProvider ?? undefined}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <IntegrationCard
            name="Payments Webhook"
            description="Webhook endpoint for payment event notifications"
            connected={details.paymentsWebhook !== null}
            value={details.paymentsWebhook ?? undefined}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
